import { IPageContext } from '@glidecms/deliver-core-dev/types/services'
import { getTaxonomyForPrimarySection } from '../taxonomy/taxonomy'
import { getImage } from '../images'
import { mapImage } from '../mappers/image'

export interface IVerticalHeader {
  title: string
  image: string
  intro: string
  standFirst: string
  meta: {
    title: string
    desc: string
  }
}

const SubVerticalImageDimensions = { height: '350', width: '910' }
const VerticalImageDimensions = { height: '350', width: '1145' }
const mediaEnvBasePath = process.env.MEDIA_BASE_PATH || ''

export const getHeader = async (
  context: IPageContext,
  isVertical: boolean
): Promise<IVerticalHeader> => {
  const taxonomy = getTaxonomyForPrimarySection(context)

  const {
    introText = '',
    image: { id: imageId = '' } = { id: '' },
    seoData: { pageTitle: metaTitle = '', metaDescription = '' } = {
      pageTitle: '',
      metaDescription: '',
    },
    shortDescription: standFirst = '',
  } = taxonomy as any

  const imageDimensions = isVertical ? VerticalImageDimensions : SubVerticalImageDimensions
  const image = await getImage(context, imageId)
  const { key: imagePath = '' } = image ? mapImage(image, imageDimensions) : {}
  const imageUrl = imagePath ? `${mediaEnvBasePath}${imagePath}` : ''

  return {
    title: taxonomy.name,
    image: imageUrl,
    intro: introText,
    standFirst,
    meta: {
      title: metaTitle,
      desc: metaDescription,
    },
  }
}
